import { Test } from "../../types/LabReport"

export const flagToTitle = (flag: string) => {
  switch (flag) {
    case "L":
      return "Low"
    case "H":
      return "High"
    case "Y":
      return "Yes"
    case "N":
      return "No"
    default:
      return flag
  }
}

export const getFlagStyles = (flag?: string | null) => {
  switch (flag) {
    case "L":
    case "H":
    case "Y":
      return "badge badge-red"
    default:
      return !!flag ? "badge badge-grey" : ""
  }
}

export const rangeToNums = (range?: string | null): [number, number] | undefined => {
  if (!range) return undefined

  let strs = range.split("-")
  if (strs.length !== 2) return undefined

  return [strToNum(strs[0]), strToNum(strs[1])]
}

export const strToNum = (str?: string | null): number => {
  const parsed = parseFloat(str ?? "0")
  return isNaN(parsed) ? 0 : parsed
}

export const formatNotes = (notes: string): string => {
  return notes.trim()
}

export const shouldDisplayGauge = (result: Test): boolean => {
  const hasNumericValue = !!result.result && !isNaN(parseFloat(result.result))
  const hasMinMax = (result: { min?: number; max?: number }): boolean => {
    if (result.min === undefined || result.max === undefined) {
      return false
    }

    if (result.min === 0 && result.max === 0) {
      return false
    }

    return true
  }

  const shouldDisplayGauge = hasNumericValue && hasMinMax(result)
  return shouldDisplayGauge
}

export const getResultValueColor = (result: Test): string => {
  // Check if the result is a numeric value
  if (!result.result || isNaN(parseFloat(result.result))) {
    return "text-gray-900"
  }

  const value = strToNum(result.result)

  // Check if there's a range to compare against
  if (result.range && result.range.length === 2) {
    const [rangeMin, rangeMax] = result.range
    if (value < rangeMin || value > rangeMax) {
      return "text-red-600"
    }
  }

  // If no range is available, use min/max if they exist
  if (result.min !== undefined && result.max !== undefined) {
    if (value < result.min || value > result.max) {
      return "text-red-600"
    }
  }

  return "text-gray-900"
}
